<template>
  <div
    :class="navClass"
    class="fixed top-0 left-0 z-50 sm:hidden flex items-center justify-between w-full bg-white px-5 transition-all duration-300"
  >
    <button
      @click="store.openNewArtwork"
      type="button"
      class="flex items-center justify-center"
    >
      <Icon name="tabler:plus" size="24" />
    </button>

    <div class="flex items-center justify-center w-1/3">
      <img
        src="@/assets/images/medium_logo.webp"
        alt=""
        class="transition-all duration-300"
        :class="imgClass"
      />
    </div>

    <button
      @click="artworkStore.openSearch"
      type="button"
      class="flex items-center justify-center"
    >
      <Icon name="tabler:search" size="24" />
    </button>
  </div>

  <!-- reserve nav space -->
  <div class="h-12 sm:hidden block"></div>
</template>

<script setup lang="ts">
import { useWindowScroll } from "@vueuse/core";
import { ref, watch } from "vue";
import { useSearchStore } from "~/stores/search";

const { y } = useWindowScroll();

const store = useNewArtworkStore();
const search = useSearchStore();
const artworkStore = useArtworkStore();
const lastY = ref(0);
const navClass = ref("h-12");
const imgClass = ref("h-9");

watch(y, (currentY) => {
  if (currentY > lastY.value && currentY > 150) {
    // scrolling down
    navClass.value = "h-11 shadow-md";
    imgClass.value = "h-8";
  } else {
    // scrolling up / near top
    navClass.value = "h-12";
    imgClass.value = "h-9";
  }

  lastY.value = currentY;
});
</script>
